import { ISieveSize, SieveSizeId } from 'Data/ViewModels/Equipment/ISieveSize';
import { CreateWorksheetSelector } from 'Components/Worksheets/Core/types';
import { combine } from 'Lib/Hooks/Selectors';

export const createWashingSieveSizeSelector = (createWorksheetSelector: CreateWorksheetSelector) =>
  combine(
    ['Equipment.WashingSieveSizeId', 'Equipment.AllSieveSizes'].map((n) => createWorksheetSelector!(n)),
    getSieveSizeFromId
  );

export const getSieveSizeFromId = (id: SieveSizeId, sieveSizes: ISieveSize[]) => {
  if (!id) return undefined;
  let sieveSize: ISieveSize | undefined = sieveSizes.find((s: ISieveSize) => s.Id === id);
  if (!sieveSize)
    throw new Error(
      `A sieve size with id ${id} was not found. This sieve size should be available for a worksheet of this type.`
    );
  return sieveSize;
};
